import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { transactionId, amount, estimatedDelivery, immediate } = location.state || {};

  if (!transactionId || !amount) {
    navigate('/payment');
    return null;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="payment-container">
      <div className="payment-success">
        <CheckCircle size={64} />
        <h2>Payment Successful!</h2>
        <div className="amount">{formatCurrency(amount)}</div>
        
        <div className="success-details">
          <p>Transaction ID: {transactionId}</p>
          {immediate ? (
            <p className="processing-time">Funds will be available immediately</p>
          ) : estimatedDelivery && (
            <p className="processing-time">
              Estimated delivery: {formatDate(estimatedDelivery)}
            </p>
          )}
        </div>

        <button
          onClick={() => navigate('/investor')}
          className="back-to-dashboard"
        >
          <ArrowLeft size={20} />
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;